<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1005028')" prop="activityTitle">
              <Input :placeholder="$t('key1005029')" v-model.trim="pageParams.activityTitle"></Input>
            </FormItem>
          </Col>
          <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1005030')">
              <local-tabButton :tabButtonList="activityStatusList" @selectStatus="activityStatusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button class="mr15" type="primary" @click="addActivityBtn" v-if="getPermission('ymsActivityPlan_save')">{{ $t('key1005031') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="520"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--提示框-->
    <Modal v-model="promptBoxModal" :title="promptBoxTitle">
      <h2 class="title">{{ promptBoxContent }}</h2>
      <template #footer>
        <Button @click="promptBoxModal = false">{{ $t('key1000112') }}</Button>
        <Button :type="promptBoxStart === 'end' ? 'error' : 'primary'" @click="promptBoxBtn">{{ promptBoxText }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {getDataSetBatchList, getEnumList} from "@/utils/common";

export default {
  name: "activityManage",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        status: null,
        activityTitle: '',
        pageNum: 1,
        pageSize: 15
      },
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005016'),
          key: 'imagePath',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            return v.tableImg(h, params, 'imagePath');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005017'),
          key: 'activityTitle',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005018'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let title = '';
            let status = params.row.status;
            v.activityStatusList.map((item) => {
              if (status !== null && status === item.value) {
                title = item.title;
              }
            });
            return h('span', title);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005019'),
          key: 'activityStartTime',
          align: 'center',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.activityStartTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005020'),
          key: 'activityEndTime',
          align: 'center',
          render: (h, params) => {
            let effectivenessStatus = params.row.effectivenessStatus;
            let time = '';
            if (effectivenessStatus === 1) {
              time = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005021');
            } else {
              time = v.$uDate.dealTime(params.row.activityEndTime, 'fulltime');
            }
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 150,
          render(h, params) {
            let status = params.row.status;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsActivityPlan_detail'),
                    clickFn: () => {
                      v.$router.push({
                        path: '/editActivity',
                        query: {
                          type: 'edit',
                          ymsActivityPlanId: params.row.ymsActivityPlanId
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005022'),
                    show: status === 0 && v.getPermission('ymsActivityPlan_updateStatus'),
                    clickFn: () => {
                      v.ymsActivityPlanId = params.row.ymsActivityPlanId;
                      v.promptBoxText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005022');
                      v.promptBoxTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005023');
                      v.promptBoxContent = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005024');
                      v.promptBoxStart = 'start';
                      v.promptBoxModal = true;
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005025'),
                    show: status === 1 && v.getPermission('ymsActivityPlan_updateStatus'),
                    color: '#D9001B',
                    clickFn: () => {
                      v.ymsActivityPlanId = params.row.ymsActivityPlanId;
                      v.promptBoxText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005025');
                      v.promptBoxTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005026');
                      v.promptBoxContent = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005027');
                      v.promptBoxStart = 'end';
                      v.promptBoxModal = true;
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      total: 0,
      promptBoxModal: false,
      promptBoxText: '',
      promptBoxTitle: '',
      promptBoxContent: '',
      promptBoxStart: null,
      ymsActivityPlanId: null,
      enumData: [],
      activityIndex: 0
    };
  },
  computed: {
    // 活动状态
    activityStatusList() {
      const ENUM_KEY = 'YmsActivityPlanStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: null,
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item,index) => {
        item.selected = index === this.activityIndex;
      });
      return list;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['YmsActivityPlanStatusCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.search();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.activityStatusBtn(0, null);
      v.getList();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsActivityPlan_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsActivityPlan_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let newList = data.list || [];
            let keyList = ['activityGoodsLabel', 'activitySlogan', 'activityTitle', 'imagePath'];
            v.tableData = v.handleMultilinguaTableFields(newList, keyList);
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
            v.$forceUpdate();
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 新增活动
    addActivityBtn() {
      this.$router.push({
        path: '/editActivity',
        query: {
          type: 'add'
        }
      });
    },
    // 选取活动状态
    activityStatusBtn(index, value) {
      this.pageParams.status = value;
      this.activityIndex = index;
    },
    // 立即开始、立即结束
    promptBoxBtn() {
      let v = this;
      v.axios.put(api.put_ymsActivityPlan_updateStatus + `${v.ymsActivityPlanId}`,
        '', {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.promptBoxModal = false;
          v.pageParamsStatus = true;
        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
